import "./GettingMsg.css";
import BrandSection from "../BrandSection/BrandSection";
import { connect } from "react-redux";
import { resolvePartnerLogo } from "../ResolveImage";

const GettingMsg = ({ partnerLogosList = [] }) => {
  const logoData = partnerLogosList
    .filter((logo) => logo.isEnabled !== false)
    .map((logo) => ({
      name: logo.name,
      img: resolvePartnerLogo(logo.imageUrl),
    }));

  return (
    <>
      <section className="getting-msg bg-white">
        <div className="container">
          <div className="getting-msg-row-wrapper">
            <div className="col-getting-msg-profile">

              <div className="founder-name">
                <h2 className="p-black align-middle display-flex display-middle" data-aos="fade-up">
                  Reputable organizations we have worked with
                </h2>
                <BrandSection images={logoData} slidesToShow={2}/>

              </div>
            </div>

            {/*<div
              className="col-getting-msg-content"
              data-aos="fade-up"
              data-aos-delay="400">
              <h2>
                Our goal is to build software that enables users who need it to
                launch their products in this pandemic and all-digital time
              </h2>
            </div> */}
          </div>
        </div>
      </section>
    </>
  );
};

const mapStateToProps = (state) => ({
  partnerLogosList: state.partnerLogos.partnerLogosList,
});

export default connect(mapStateToProps)(GettingMsg);
